const getSolicitations = (state) => {
  return state.solicitacoes
}

const getSolicitationsPrimeiroCarregamento = (state) => {
  return state.solicitacoesPrimeiroCarregamento
}

const getFilesByHistoric = (state) => {
  return state.arquivos
}

const getReasonsSabesp = (state) => {
  return state.reasonsSabesp
}

const getGroupedSolicitations = (state) => {
  return state.groupedSolicitations
}

const getGroupedSolicitationsStatus = (state) => {
  return state.groupedSolicitationsStatus
}

const getModalAddMsgSolicitationInfo = (state) => {
  return state.modalAddMsgSolicitationInfo
}

const getOverlap = (state) => {
  return state.overlap
}

const getActiveProtocol = (state) => {
  return state.activeProtocol
}

const getSolicitationToView = (state) => {
  return state.solicitationToView
}

const getInfoHistoricAlter = (state) => {
  return state.modalAlterHistoricoData
}

const getAlterPermissionCancel = (state) => {
  return state.alterCancelPermission
}

const getAlterCancelChanges = (state) => {
  return state.alterCancelChanges
}

export default {
  getSolicitations,
  getFilesByHistoric,
  getReasonsSabesp,
  getSolicitationsPrimeiroCarregamento,
  getGroupedSolicitations,
  getGroupedSolicitationsStatus,
  getModalAddMsgSolicitationInfo,
  getOverlap,
  getActiveProtocol,
  getSolicitationToView,
  getInfoHistoricAlter,
  getAlterPermissionCancel,
  getAlterCancelChanges
}
